<template>
  <md-empty-state
    md-icon="wifi_off"
    class="md-accent"
    md-label="No se encontró conexión a internet"
    md-description="Para poder acceder a este módulo es necesario una conexión a internet"
  />
</template>
<script>
export default {
  name: "InternetRequired"
};
</script>